import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import cartIcon from "../../assets/images/cartfff.png";
import loadingIcon from "../../assets/images/loading.gif";
import { useSelector } from "react-redux";

function CartLink(props) {
  const { t } = useTranslation();
  const location = useLocation();
  const cart = useSelector((state) => state.cart);
  const [totalQty, setTotalQty] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const isActive = (path) => (location.pathname === path ? "active" : "");
  useEffect(() => {
    setIsLoading(cart.loading);
    if (cart?.cartData?.items) {
      setTotalQty(cart?.cartData?.items?.length);
    }
    if(cart?.cartData == null || cart?.cartData?.length <= 0 || cart?.length <= 0) {
      setTotalQty(0);
    }
  }, [cart]);
  return (
    <Link to="/cart" className={isActive("/cart")}>
      <img src={cartIcon} alt="" width="35" height="36" />
      <p className={`cart-qty-wrapper cart ${isActive("/cart")}`}>
        {t("cart")}
        {isLoading && (
          <span className="loading">
            <img src={loadingIcon} alt="Loading..." />
          </span>
        )}
        <span className={totalQty.toString().length > 4?'cart-qty size-12':'cart-qty'}>{totalQty}</span>
      </p>
    </Link>
  );
}

export default CartLink;
